import moment from 'moment'
import {TableState} from './interfaces'

const initialState: TableState = {
  InterperterInvoice: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        fromDate: '',
        toDate: moment().format('YYYY-MM-DD'),
        company: [],
        status: [],
      },
    },
  ],

  RequesterManagement: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        joinDate: null,
        loginDate: null,
        customers: [],
        status: [],
        roles: [],
        accountLevel: '',
      },
    },
  ],

  InterperterManagement: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        joinDate: null,
        loginDate: null,
        status: [],
      },
    },
  ],

  AdministratorManagement: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        joinDate: null,
        loginDate: null,
        status: [],
        role: [],
      },
    },
  ],

  CompanyUserManagement: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      customerCode: 0,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        joinDate: null,
        loginDate: null,
        status: [],
        roles: [],
        accountLevel: '',
      },
    },
  ],

  CustomerInvoice: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        fromDate: '',
        toDate: moment().format('YYYY-MM-DD'),
        company: [],
        status: [],
      },
    },
  ],

  dashboardCallLogsOnDEmand: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 1,
      },
    },
  ],

  dashboardCallLogsScheduled: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 0,
      },
    },
  ],

  dashboardCallLogsInPerson: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 2,
      },
    },
  ],

  dashboardCallLogsOperator: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 3,
      },
    },
  ],

  dashboardCallLogsEffectiff: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 5,
      },
    },
  ],

  dashboardCallLogsOPI: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        awsUserId_REQList: [],
        awsUserId_INTList: [],
        customerList: [],
        languageList: [],
        callStateList: [],
        serviceTypeList: [],
        backstopPartnerList: [],
        startDate: null,
        endDate: null,
        callType: 1,
        aiQcStatus: '',
        noiseLevels: [],
      },
    },
  ],

  CustomerUnInvoicedCalls: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        languageList: [],
        coustomerList: [],
        startDate: null,
        endDate: null,
        callType: 50,
        appointmentStatusList: [],
        meetingSummaryStatusList: [],
      },
    },
  ],

  dashboardOverview: [
    {
      filter: 5,
      communicationTypes: [],
    },
  ],

  InterpreterUnInvoicedCalls: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        languageList: [],
        awsUserId_INTList: [],
        startDate: null,
        endDate: null,
        callType: 50,
        appointmentStatusList: [],
        meetingSummaryStatusList: [],
      },
    },
  ],

  appointmentsCallender: [
    {
      date: moment().format('YYYY-MM-DD'),
      sortBy: 'time',
      sortOrder: 'asc',
      filterData: {
        accounts: [],
        subaccounts: [],
        communicationTypes: [],
        langs: [],
        serviceTypes: [],
        interpreters: [],
        requesters: [],
      },
    },
  ],

  allAppointments: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        accounts: [],
        subaccounts: [],
        communicationTypes: [],
        langs: [],
        serviceTypes: [],
        startDate: null,
        endDate: null,
        status: [],
        canceledStatus: [],
        interpreters: [],
        requesters: [],
      },
    },
  ],

  upcomingAppoinment: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      searchQuery: '',
      filterData: {
        accounts: [],
        subaccounts: [],
        communicationTypes: [],
        langs: [],
        serviceTypes: [],
        requesters: [],
        UpcomingAppointmentFilter: null,
      },
    },
  ],

  customerManagement: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        countries: [],
        status: [],
        accountLevel: '',
      },
    },
  ],

  occupancyReport: [
    {
      currentPage: 1,
      rowsPerPage: 10,
      sort: null,
      order: null,
      searchQuery: '',
      filterData: {
        awsUserId_INTList: [],
        startDate: null,
        endDate: null,
      },
    },
  ],
}

export default initialState
